<template>
    <div>
        <ac-modal title="Payment History" ref="modalRef">
            <template>
                <div class="form-group">
                    <table ref="grid" class="mdl-data-table table table-responsive dataTable no-footer dtr-inline"
                        width="100%">
                    </table>
                </div>
                <div class="button-box" style="margin-top: 10px;">
                    <ac-button class="btn btn-sm btn-red" :action="closeModal">CLOSE</ac-button>
                </div>
            </template>
        </ac-modal>
        <ac-confirmation-modal ref="confirmModal" :size-class="'modal-md'"
                                :title="'Refund Payment?'"
                                :accept-button="'I Agree'">
            <p>
                Are you sure you want to refund the {{this.amount | currency}} for coverage from {{ this.effStart | shortDate }} to {{ this.effEnd | shortDate }}?
            </p>
        </ac-confirmation-modal>
    </div>
</template>

<script>
    import {common} from "../../../../global/common.js";
    import {api} from "../../../../global/framework/api.js";
    import { formatter } from "../../../../global/formatter.js";

    export default {
        name: "PaymentHistoryModal",
        data() {
            return {
                grid: null,
                viewOnly: false,
                consumerId: null,
                amount: 0,
                effStart: null,
                effEnd: null
            };
        },
        methods: {
            async showModal(consumer) {
                this.consumerId = consumer.consumerId;

                await this.initOrReloadGrid();

                this.addClickEvents();
                this.$refs.modalRef.open();
            },
            async initOrReloadGrid(){
                var data = await api.get("Admin", this.consumerId, "GetConsumerCCPayments");

                if (this.grid !== null) {
                    common.reloadGrid(this.grid, data);
                    return;
                }

                this.grid = $(this.$refs.grid).DataTable({
                    responsive: true,
                    data: data,
                    order: [[0, "asc"]],
                    displayLength: 15,
                    columns: [
                        { title: "Id", data: "paymentRecordId" },
                        { 
                            title: "Amount", data: "paymentAmount",
                            render(data) { return formatter.formatCurrency(data); }
                        },
                        {
                            title: "Cov Eff Start", data: "coverageEffectiveStartDate", 
                            render: function (data) { return formatter.formatRawDateSort(data, true); }
                        },
                        {
                            title: "Options", data: null, render(data, type, row) {
                                return '<ac-button class="btn-sm btn-success wl-btn-success button-size refund-btn" style="cursor:pointer;">Refund</ac-button>';
                            }
                        },
                    ]
                });
            },
            closeModal() {
                this.$refs.modalRef.close();
            },
            addClickEvents(){
                let self = this;
                $(self.$refs.grid).off('click', '.refund-btn').on('click', '.refund-btn', function (e) {
                    let rowData = common.getRowData(this, self.grid);
                    self.amount = rowData.paymentAmount;
                    self.effStart = rowData.coverageEffectiveStartDate;
                    self.effEnd = rowData.coverageEffectiveEndDate;
                    self.refundPayment(rowData.paymentRecordId);
                });
            },
            async refundPayment(paymentId) {
                let agree = await this.$refs.confirmModal.showModal();
                if (agree) {
                    let result = await api.postWithId('Admin', this.consumerId, 'RefundPayment/' + paymentId);
                    if(result) {
                        await this.initOrReloadGrid();
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>